<template>
    <div class="page-contact">
        <div class="header">
            <div class="header-left">
                <img src="@/assets/img/logo@2x.png" @click="$router.push({ path: '/' })" class="logo" alt="">
            </div>
            <div class="nav">
                <div class="nav-item" @click="$router.push({ path: '/' })">
                    首页
                </div>
                <div class="nav-item" @click="$router.push({ path: '/aboutUs' })" >
                    关于我们
                </div>
                <div class="nav-item" @click="$router.push({ path: '/webC' })">
                    项目介绍
                </div>
                <div class="nav-item">
                    联系我们
                </div>
            </div>
        </div>
        <div class="banner">
            <img src="@/assets/img/banner@2x.png" class="banner-img" alt=""></img>
        </div>

        <div class="content">
            <div class="content-left">
                <div class="tit">四川联裕科技信息有限公司</div>
                <div class="phone">联系电话：谢茜 18808258011 / 张悦悦 18482571438</div>
                <div class="email">邮箱：SANGE8011@163.COM</div>
                <div class="address">地址：四川省射洪市聚贤路73号</div>
            </div>
            <div class="content-right">
                <img src="@/assets/img/blueLoGo2@2x.png" class="blue-logo" alt="">
            </div>
        </div>

        <div class="map">
            <img src="@/assets/img/map@2x.png" class="map-img" alt="">
        </div>

        <div class="footer">
            <div class="company">四川联裕科技信息有限公司</div>
            <div class="beian" @click="openUrl('https://beian.miit.gov.cn/#/Integrated/index')">
                蜀ICP备2024044808号-4
            </div>
        </div>
    </div>
</template>

<script>
export default {
    components: {},
    props: {},
    data() {
        return {};
    },
    computed: {},
    watch: {},
    created() { },
    mounted() { },
    methods: {
        openUrl(url) {
            window.open(url);
        }
    },
};
</script>
<style scoped lang="less">
.logo {
    width: 231px;
    height: 101px;
    margin-left: 136px;
}

.page-contact {
    height: 100%;
    overflow-y: auto;
    // position: relative;
}

.header {
    width: 100%;
    height: 153px;
    background-color: rgba(12, 21, 27, .6);
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: fixed;
    top: 0;
    left: 0;

    .header-left {
        cursor: pointer;
    }

    .nav {
        display: flex;
        margin-right: 121px;
        width: 594px;
        justify-content: space-between;

        .nav-item {
            font-family: Source Han Sans CN;
            font-weight: 400;
            font-size: 21px;
            color: #FFFFFF;
            line-height: 29px;
            cursor: pointer;
        }
    }

    .banner-img {
        width: 100%;
        height: 828px;
    }
}

.banner{
    padding-top: 153px;
}

.content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-top: 195px;
    padding-bottom: 147px;

    .content-left {
        margin-left: 186px;

        .tit {
            font-size: 46px;
            line-height: 100px;
            font-family: Source Han Sans CN;
        }

        .phone {
            font-size: 33px;
            line-height: 100px;
            font-family: Source Han Sans CN;
        }

        .email {
            font-size: 33px;
            line-height: 100px;
            font-family: Source Han Sans CN;
        }

        .address {
            font-size: 33px;
            line-height: 100px;
            font-family: Source Han Sans CN;
        }

    }

    .content-right {
        margin-right: 124px;

        .blue-logo {
            width: 445px;
            height: 194px;
        }
    }
}

.map {
    margin: 0 124px;
    padding-bottom: 147px;
    width: 100%;

    .map-img {
        width: calc(100% - 248px);

        height: 835px;
    }
}

.footer {
    padding-top: 50px;
    padding-bottom: 51px;
    width: 100%;
    background-color: rgba(39, 39, 39, 1);
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 21px;
    color: #FFFFFF;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
}
</style>